window._ = require('lodash')
window._axios = require('axios')
window.AuthEloquent = require('./Eloquent').default
window._DefaultCancelKey = 'GLOBAL_CANCEL_SOURCE'
window._CancelSourceMap = {
    GLOBAL_CANCEL_SOURCE: _axios.CancelToken.source()
}

/**
 * Declared _BaseAxios, because _axios is modified below,
 * _BaseAxios is need in creating new Cancel Token
 */
window._BaseAxios = require('axios')

const baseUrls = {
    local: 'http://rmd-main.local',
    production: 'https://icy-mountain-vxvozjijbhpr.vapor-farm-a1.com',
    development: 'https://bountiful-sanctuary-ljvifnbtcaji.vapor-farm-a1.com',
    delivery: 'https://dev-api.paper-trader.com'
}

let settings = {
    //todo change urls
    baseDomain: baseUrls[process.env.NODE_ENV]
}

if (process.env.NODE_ENV !== 'production') {
    if (window._playground) {
        settings = {
            baseDomain: ''
        }
    }
}

_axios = _axios.create({
    baseURL: settings.baseDomain,
    withCredentials: true
})

_axios.defaults.validateStatus = status => {
    return status >= 200 && status < 500
}

_axios.interceptors.response.use(response => {
    response.isOk = response.status >= 200 && response.status < 300
    return response
})

const models = {
    Auth: require('./Auth').default,
    User: require('./User').default,
    Notifications: require('./Notifications').default,
    Upload: require('./Upload').default,
    FirebaseTokens: require('./FirebaseTokens').default,
}

_.each(models, (modelFunctions, modelName) => {
    AuthEloquent[modelName] = AuthEloquent._makeClass(modelName, modelFunctions)
})
